import React from 'react';

import { Dialog, Typography } from '@material-ui/core';

import DialogGrid from 'containers/DialogGrid/DialogGrid';

import useStyles from './SheetsTimerHelpDialog.styles';

type Props = {
  open: boolean;
  onClose: () => void;
};

const SheetsTimerHelpDialog: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog onClose={onClose} maxWidth='sm' open={open}>
      <DialogGrid
        cancelClick={onClose}
        hideCancelButton
        hideCloseButton
        okClick={onClose}
        okLabel='Rozumiem'
        title='Czas trwania egzaminu maturalnego'
      >
        <div className={classes.root}>
          <div>
            <Typography className={classes.sectionTitle} color='primary'>
              Typowe czasy egzaminów pisemnych (Formuła 2023)
            </Typography>
            <ul className={classes.list}>
              <li>
                <Typography>
                  Język polski (poziom podstawowy): <span className={classes.numberValue}>240</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Język polski (poziom rozszerzony): <span className={classes.numberValue}>210</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Matematyka (poziom podstawowy i rozszerzony): <span className={classes.numberValue}>180</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Język obcy nowożytny (poziom podstawowy): <span className={classes.numberValue}>120</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Język obcy (poziom rozszerzony): <span className={classes.numberValue}>150</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Język obcy (poziom dwujęzyczny): <span className={classes.numberValue}>180</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Pozostałe przedmioty na poziomie rozszerzonym (m.in. biologia, chemia, fizyka, geografia, historia):{' '}
                  <span className={classes.numberValue}>180</span> minut
                </Typography>
              </li>
              <li>
                <Typography>
                  Informatyka (poziom rozszerzony): <span className={classes.numberValue}>210</span> minut
                </Typography>
              </li>
            </ul>
          </div>
          <div>
            <Typography className={classes.sectionTitle} color='primary'>
              Dodatkowy czas
            </Typography>
            <Typography className={classes.note}>
              Zgodnie z przepisami CKE, w części pisemnej egzaminu maturalnego można otrzymać przedłużenie czasu z danego
              przedmiotu nie więcej niż o <span className={classes.numberValue}>30</span> minut na każdy arkusz egzaminacyjny. Dodatkowy czas można wykorzystać na
              rozwiązywanie zadań lub przerwy, w zależności od indywidualnych potrzeb. Decyzję o dostosowaniach podejmuje
              dyrektor szkoły na podstawie dokumentacji (np. orzeczenia o potrzebie kształcenia specjalnego lub zaświadczenia
              lekarskiego).
            </Typography>
          </div>
        </div>
      </DialogGrid>
    </Dialog>
  );
};

export default SheetsTimerHelpDialog;
